import { render, staticRenderFns } from "./pertama.vue?vue&type=template&id=5e65a414&scoped=true"
import script from "./pertama.vue?vue&type=script&lang=js"
export * from "./pertama.vue?vue&type=script&lang=js"
import style0 from "./pertama.vue?vue&type=style&index=0&id=5e65a414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e65a414",
  null
  
)

export default component.exports